import { useField } from 'formik';
import { FormsGroup } from './FormsGroup';
import { useFormLabel } from './FormsI18nContext';
import React from 'react';
import { RichTextEditor, RichTextImageProps } from '../RichTextEditor';

export interface FormsRichTextEditorProps extends RichTextImageProps {
  name: string;
  label?: React.ReactNode;
  required?: boolean;
  className?: string;
  disabled?: boolean;
}

export const FormsRichTextEditor = (props: FormsRichTextEditorProps) => {
  const {
    name,
    label: labelOverride,
    required,
    disabled,
    setAttachmentIds,
    ownerId,
    ownerType,
  } = props;
  const [, { value }, { setValue }] = useField(name);

  const label = useFormLabel(name, labelOverride);

  return (
    <FormsGroup name={name} required={required} label={label}>
      <RichTextEditor
        value={value}
        disabled={disabled}
        onChange={setValue}
        setAttachmentIds={setAttachmentIds}
        ownerId={ownerId}
        ownerType={ownerType}
      />
    </FormsGroup>
  );
};
